import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { Button } from '@medely/ui-kit';
import { AddExperienceModalInfo } from './AddExperienceModalInfo';
import { ArrowLeft } from '@medely/web-components/icons';
import { AddExperienceModalProps } from './interface';

export const AddExperienceModal = ({ open, onClose }: AddExperienceModalProps) => {
  return (
    <BottomSheetDialog
      open={open}
      disableRestoreFocus
      content={
        <>
          <Button
            variant="text"
            onClick={onClose}
            startIcon={<ArrowLeft />}
            testId="add-experience-modal-back-button"
          >
            Back
          </Button>
          <AddExperienceModalInfo onClose={onClose} />
        </>
      }
      isDesktop={false}
    />
  );
};
